import React, { useState, useEffect } from "react";
import { Button } from "./ui/button.jsx";
import { Menu, X } from "lucide-react";
import Logo from "./Logo.tsx";

const Navigation: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState<boolean>(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState<boolean>(false);

  useEffect(() => {
    const handleScroll = (): void => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    // Prevent body scroll when mobile menu is open
    if (isMobileMenuOpen) {
      document.body.classList.add('no-scroll');
    } else {
      document.body.classList.remove('no-scroll');
    }

    return () => {
      document.body.classList.remove('no-scroll');
    };
  }, [isMobileMenuOpen]);

  const scrollToSection = (sectionId: string): void => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
      setIsMobileMenuOpen(false); // Close mobile menu after navigation
    }
  };

  const toggleMobileMenu = (): void => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <>
      <nav className={`dark-header ${isScrolled ? "scrolled" : ""}`}>
        <div className="nav-content">
          <Logo
            size="medium"
            className="nav-logo"
            onClick={() => scrollToSection("top")}
          />

          <div className="dark-nav">
            <button
              className="dark-nav-link"
              onClick={() => scrollToSection("services")}
            >
              Услуги
            </button>
            <button
              className="dark-nav-link"
              onClick={() => scrollToSection("process")}
            >
              Процесс
            </button>
            <button
              className="dark-nav-link"
              onClick={() => scrollToSection("technology")}
            >
              Технологии
            </button>
            <button
              className="dark-nav-link"
              onClick={() => scrollToSection("contact")}
            >
              Контакты
            </button>
          </div>

          <div className="nav-right">
            <Button
              className="btn-primary nav-cta"
              onClick={() => scrollToSection("contact")}
            >
              Обсудить проект
            </Button>

            {/* Mobile Menu Toggle */}
            <button
              className="mobile-nav-toggle"
              onClick={toggleMobileMenu}
              aria-label="Toggle mobile menu"
            >
              {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile Navigation Menu */}
      <div className={`mobile-nav ${isMobileMenuOpen ? 'active' : ''}`}>
        <div className="mobile-nav-content">

          <button
            className="mobile-nav-link"
            onClick={() => scrollToSection("services")}
          >
            Услуги
          </button>
          <button
            className="mobile-nav-link"
            onClick={() => scrollToSection("process")}
          >
            Процесс
          </button>
          <button
            className="mobile-nav-link"
            onClick={() => scrollToSection("technology")}
          >
            Технологии
          </button>
          <button
            className="mobile-nav-link"
            onClick={() => scrollToSection("contact")}
          >
            Контакты
          </button>
          <Button
            className="btn-primary mobile-cta"
            onClick={() => scrollToSection("contact")}
          >
            Обсудить проект
          </Button>
        </div>
      </div>
    </>
  );
};

export default Navigation;